import { WORKOUT_EXERCISE_KEY } from '@gymaholic/packages'
import { View } from 'components/View'
import memoize from 'memoize-one'
import getIdReduxUtil from 'modules/redux/utils/get-id'
import getValueReduxUtil from 'modules/redux/utils/get-value'
import SetRow from 'pages/Creator/SetRow'
import React, { memo } from 'react'
import Link from 'components/Link'
import {
  areEqual,
  FixedSizeList
} from 'react-window'
import useSelector from 'modules/component/utils/hooks/useSelector.js'
import {
  getHeightViewportSelect,
  isMobileScreenViewportSelect
} from 'modules/viewport/selectors/index.js'
import { getPaddingHorizontalWorkoutSelect } from 'pages/Workout/redux/selectors/get-padding-horizontal/index.js'
import { getListWidthAppSelect } from 'modules/app/selectors/getListWidth/index.js'

const ListRow = memo(({
  data,
  index,
  style
}) => {
  const {
    items,
    handleClickSetType,
    handleClickSetValue,
    handleClickWeight,
    isWorkoutScreen,
    setIndex,
    workoutSectionId,
    pathname,
    onClick,
    isCreator,
    needsPremium
  } = data

  const renderSetRow = () => {
    return (
      <SetRow
        workoutExerciseId={getIdReduxUtil(items[index])}
        setData={getValueReduxUtil(items[index], WORKOUT_EXERCISE_KEY.SET_DATA)}
        handleClickSetValue={needsPremium ? null : () => handleClickSetValue(items[index])}
        handleClickSetType={needsPremium ? null : () => handleClickSetType(items[index])}
        handleClickWeight={needsPremium ? null : () => handleClickWeight(items[index])}
        isSelected={isWorkoutScreen || Number(setIndex) === Number(index)}
        isWorkoutScreen={isWorkoutScreen}
        workoutSectionId={workoutSectionId}
      />
    )
  }

  let queryParams = `?workoutSectionId=${workoutSectionId}&workoutExerciseId=${getIdReduxUtil(items[index])}&setIndex=${index}`

  if (isCreator) {
    queryParams = queryParams + '&isCreator=true'
  }

  if (workoutSectionId) {
    const handleClick = () => {
      onClick?.(index)
    }

    let Component
    const componentProps = {}
    if (onClick) {
      Component = Link
      componentProps.to = `${pathname}${queryParams}`
      componentProps.onClick = handleClick
    } else {
      Component = View
    }
    return (
      <View style={style}>
        <Component
          {...componentProps}
        >
          {renderSetRow()}
        </Component>
      </View>
    )
  }

  return (
    <View style={style}>
      {renderSetRow()}
    </View>
  )
}, areEqual)

const createItemData = memoize((items, handleClickSetType, handleClickSetValue, handleClickWeight, isWorkoutScreen, setIndex, workoutSectionId, pathname, onClick, isCreator, needsPremium) => ({
  items,
  handleClickSetType,
  handleClickSetValue,
  handleClickWeight,
  isWorkoutScreen,
  setIndex,
  workoutSectionId,
  pathname,
  onClick,
  isCreator,
  needsPremium
}))

const HEIGHT_RATIO = 0.3

function SetList ({
  items,
  handleClickSetValue,
  handleClickSetType,
  handleClickWeight,
  isWorkoutScreen,
  setIndex,
  workoutSectionId,
  pathname,
  onClick,
  isCreator,
  needsPremium
}) {
  const isMobileScreen = useSelector(isMobileScreenViewportSelect)
  const itemData = createItemData(items, handleClickSetType, handleClickSetValue, handleClickWeight, isWorkoutScreen, setIndex, workoutSectionId, pathname, onClick, isCreator, needsPremium)
  const viewportHeight = useSelector(getHeightViewportSelect)
  const height = viewportHeight * HEIGHT_RATIO
  const ref = React.useRef()
  const paddingHorizontal = useSelector(getPaddingHorizontalWorkoutSelect)
  const listWidth = useSelector(getListWidthAppSelect)

  const handleUpdate = () => {
    ref.current?.scrollToItem(0)
  }

  React.useEffect(() => {
    handleUpdate()
  }, [workoutSectionId])

  return (
    <View
      px={paddingHorizontal}
      style={{
        alignItems: isMobileScreen
          ? 'unset'
          : 'center',
        boxSizing: 'border-box'
      }}
    >
      <FixedSizeList
        ref={ref}
        className='no-scrollbars'
        height={height}
        itemCount={items.length}
        itemData={itemData}
        itemSize={115}
        width={
          isMobileScreen
            ? 'unset'
            : listWidth
        }
      >
        {ListRow}
      </FixedSizeList>
    </View>
  )
}

export default SetList
